import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef } from "react";
import useToggle from "../hooks/useToggle";
var Dropdown = function (_a) {
    var text = _a.text, onOpenCallback = _a.onOpenCallback, _b = _a.color, color = _b === void 0 ? "white" : _b, children = _a.children;
    var _c = useToggle(), isOpen = _c[0], toggle = _c[2];
    var dropDownIcon = isOpen ? "chevron-up" : "chevron-down";
    var divRef = useRef(null);
    var onClick = function () {
        toggle();
        if (onOpenCallback && !isOpen)
            onOpenCallback();
    };
    return (_jsxs("div", { ref: divRef, className: "inline-block", children: [_jsxs("div", { className: "cursor-pointer", onClick: onClick, "data-testid": "dropdown", children: [_jsx("span", { className: "text-".concat(color, " mr-2 textL select-none"), children: text }), _jsx(FontAwesomeIcon, { icon: ["fas", dropDownIcon], color: color })] }), _jsx("div", { className: isOpen ? "" : "hidden", children: children })] }));
};
export default Dropdown;
